"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicUrlConstants = void 0;
var loc = globalThis.location || {};
var ROOT_URL = loc.protocol + '//' + loc.host;
var JSON_API_ROOT_URL = ROOT_URL + "/JsonServiceApi";
var SALESFORCE_SERVICE_API_ROOT_URL = ROOT_URL + "/SalesforceServiceApi";
exports.SeismicUrlConstants = {
    ROOT_URL: ROOT_URL,
    IMAGE_DOWNLOAD_URL: ROOT_URL + '/ImageHandler/DownloadImage.aspx',
    FILE_SERVICE_URL: ROOT_URL + '/Resource',
    SSO_LOGIN_URL: ROOT_URL + '/Logon.aspx',
    SSO_LOGOUT_URL: ROOT_URL + '/Logout.aspx',
    UPLOAD_URL: ROOT_URL + '/Upload',
    YOUTUBE_VIDEO: ROOT_URL + '/VideoHandler/PlayVideoStreaming.aspx',
    DOWNLOAD_ROOT_URL: '/Download',
    DOWNLOAD_SIGNATURE_IN_COOKIE: 'ImageLoader',
    JSON_API_ROOT_URL: ROOT_URL + '/JsonServiceApi',
    USER_SERVICE_URL: JSON_API_ROOT_URL + '/UserService.svc',
    DOC_CENTER_SERVICE_URL: JSON_API_ROOT_URL + '/DocCenterServiceV4.svc',
    NEWS_CENTER_SERVICE_URL: JSON_API_ROOT_URL + '/NewsCenterService.svc',
    LIBRARY_SERVICE_URL: JSON_API_ROOT_URL + '/LibraryService.svc',
    LIVESHARE_SERVICE_URL: JSON_API_ROOT_URL + '/LiveShareManagementService.svc',
    LIVESHARE_TRACE_SERVICE_URL: JSON_API_ROOT_URL + '/LiveShareTraceService.svc',
    NOTIFICATION_SERVICE: JSON_API_ROOT_URL + '/NotificationService.svc',
    PAGELAYOIUT_SERVICE_URL: JSON_API_ROOT_URL + '/PageLayoutManagementService.svc',
    USER_MANAGEMENT_URL: JSON_API_ROOT_URL + '/UserManagementService.svc',
    CONTENT_OBJECT_SERVICE_URL: JSON_API_ROOT_URL + '/ContentObjectService.svc',
    FORM_SERVICE_URL: JSON_API_ROOT_URL + '/FormService.svc',
    DISTRIBUTION_SERVICE_URL: JSON_API_ROOT_URL + '/DistributionService.svc',
    PREVIEW_SERVICE_URL: JSON_API_ROOT_URL + '/PreviewService.svc',
    DELIVERYCENTERSERVICE_SERVICE_URL: JSON_API_ROOT_URL + '/DeliveryCenterService.svc',
    CONTENT_DELIVERY_OPTION_SERVICE_URL: JSON_API_ROOT_URL + '/ContentDeliveryOptionService.svc',
    WOPI_SERVICE_URL: JSON_API_ROOT_URL + '/WOPIService.svc',
    DATASOURCE_OBJECT_SERVICE: JSON_API_ROOT_URL + '/DataSourceObjectService.svc',
    PLUGININ_SERVICE_URL: JSON_API_ROOT_URL + '/PluginService.svc',
    CLIENTAPP_ADMIN_SERVICE_URL: JSON_API_ROOT_URL + '/ClientAppAdminService.svc',
    CONTENT_PROFILE_SERVICE: JSON_API_ROOT_URL + '/ContentProfileService.svc',
    TEAM_SITE_SERVICE: JSON_API_ROOT_URL + '/TeamSiteService.svc',
    USER_EXTERNAL_MAPPING_SERVICE_URL: JSON_API_ROOT_URL + '/UserExternalMappingService.svc',
    CONTACT_SERVICE_URL: JSON_API_ROOT_URL + '/ContactService.svc',
    SALESFORCE_SERVICE_API_ROOT_URL: SALESFORCE_SERVICE_API_ROOT_URL,
    SALESFORCE_DISTRIBUTION_SERVICE: SALESFORCE_SERVICE_API_ROOT_URL + '/DistributionService.svc',
    SALESFORCE_USER_SERVICE: SALESFORCE_SERVICE_API_ROOT_URL + '/UserService.svc',
    DATA_AND_REPORTS_SERVICE_URL: JSON_API_ROOT_URL + '/DataAndReportsService.svc',
    SF_DOC_CENTER_TAB_PATH: '/H5/SFDCDocCenter.aspx',
};
//# sourceMappingURL=SeismicUrlConstants.js.map